export enum DataRoomModalType {
  CREATE_FOLDER = 'create-folder',
  CREATE_SPACE = 'create-space',
  DATA_ROOM_SETTINGS = 'data-room-settings',
  DELETE_DATA_ROOM = 'delete-data-room',
  DELETE_SPACE_NODE = 'delete-space-node',
  DELETE_WORKSPACE = 'delete-workspace',
  MANAGE_ACCESS = 'manage-access',
  RENAME_SPACE_NODE = 'rename-space-node',
  RENAME_VAULT_FILE = 'rename-vault-file',
  WORKSPACE_SETTINGS = 'workspace-settings',
}
